import React from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import MainComponent from "../../routes/mainComponent/MainComponent";

class App extends React.Component {
  render() {
    return <MainComponent />;
  }
}

export default App;
